import { Palette } from '@common/theming/Palette';
import React from 'react';
import { AssetBlockProps } from '../../pages/AssetApp';
import { TextBlock } from '../TextBlock';
import InfoTable from './InfoTable';
import ProfileAssetHeading from './ProfileAssetHeading';

const AssetDetails: React.FC<AssetBlockProps> = ({ asset }) => {
  return (
    <div>
      <ProfileAssetHeading heading={asset.assetDetails?.heading} />
      <div style={{ marginTop: 20 }}>
        <InfoTable rows={asset.assetDetails?.rows || []} field="assetDetails" />
      </div>
      <TextBlock color={Palette.WHITE_70} style={{ marginLeft: 5, marginTop: 12 }}>
        {asset.assetDetails?.disclaimer}
      </TextBlock>
    </div>
  );
};

export default AssetDetails;
